
import { EP_SEND_MESSAGE } from '../constants/endPointConstants';
import api from './Api';
import { formatStringPlaceholder } from './CommonService';

const sendMessage = async (roomId, playerId, message) => {
    const response = await api.post(`${formatStringPlaceholder(EP_SEND_MESSAGE, {roomId: roomId, playerId: playerId})}`, message);
    return response.data;
}

export {sendMessage}